import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {RecordData, RecordUpdateRequestData} from "../../../types/records-table.types";
import {baseUrl} from "../../../constants/base-url";
import {HttpClient} from "@angular/common/http";
import {AttachProps, DetachProps} from "../../../types/attach-detach.types";
import {resources} from "../../../models/resource/resources";
import {jsonPathHeaders} from "../../../models/http-headers";
import {GetRecordPropertyDataByIdParams} from "../base-modal/types/base-modal.types";

@Injectable({
  providedIn: 'root'
})
export class BaseModalApiService {
  private http: HttpClient = inject(HttpClient);

  public fetchDataById<T>({ path, resourceId }: GetRecordPropertyDataByIdParams): Observable<T> {
    return this.http.get<T>(`${baseUrl}/${path}/${resourceId}`)
  }

  public updateRecordData(recordDataUpdate: RecordUpdateRequestData): Observable<RecordData> {
    const { path, recordId, ...recordData } = recordDataUpdate;

    return this.http.put<RecordData>(`${baseUrl}/${path}/${recordId}`, recordData, {
      headers: jsonPathHeaders
    })
  }

  public attachRecordData({ path, id, recordCalendarId }: AttachProps): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${path}/attach`, {}, {
      params: {
        id: id,
        recordCalendarId: recordCalendarId
      }
    });
  }

  public detachRecordData({ path, recordCalendarId }: DetachProps): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${path}/detach`, {}, {
      params: {
        recordCalendarId: recordCalendarId
      }
    });
  }

  public changeUserPassword(login: string, password: string): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${resources['users'].path}/password`, {}, {
      params: {
        login,
        password
      }
    })
  }

  public createDataInModal<T, K>(createData: T, path: string): Observable<K> {
    return this.http.post<K>(`${baseUrl}/${path}`, createData);
  }
}
